<div class="flex flex-column md:flex-row gap-5" style="min-height: 81vh">
    <div class="md:w-25rem card p-0">
        <app-chat-sidebar></app-chat-sidebar>
    </div>
    <div class="flex-1 card p-0">
        <app-chat-box [user]="activeUser"></app-chat-box>
    </div>
</div>